import { render, staticRenderFns } from "./ClientsCadorTableItem.vue?vue&type=template&id=62a04cae&scoped=true"
import script from "./ClientsCadorTableItem.vue?vue&type=script&lang=js"
export * from "./ClientsCadorTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a04cae",
  null
  
)

export default component.exports